export default "__VITE_ASSET__BIDlMLO1__"